import React from "react";

const NavText = (props) => {
  return (
    <>
      <div className="logo-nav">
        {/* <p className="logo-nav-sweat-text">{props.planname}</p> */}
        <p className="logo-nav-sweat-text">Sweat Fit Wellness</p>
        <p>{`>`}</p>
        <p className="logo-nav-last-text">{props.name}</p>
        <p>{`>`}</p>
        {props.currentPageText ? <p className="logo-nav-last-text">{props.currentPageText}</p> : ''}
      </div>
    </>
  );
};

export default NavText;
